/**
 * @desc 根据数据字典查询SKU产品模式下的产品线负责人
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/queryTheProductLineManagerInSkuProductModeAccordingToTheDataDictionary`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
